import { ColumnHelper } from "@tanstack/react-table";
import { ResourceTableOption } from "PFApp/components/resource_table_toggle";
import { LoadingDots } from "PFComponents/loading_dots";
import Table from "PFComponents/table";
import { useProfilesOptions } from "PFCore/hooks/queries/profiles/use_profiles_options";
import { BasicProfile } from "PFTypes";
import { useCallback } from "react";

import { RenderActionCell, RowSelection } from "../../../resource_table_toggle";
import { createWorkforceMemberColumn } from "./workforce_member_column";

type NamedResourceTableProps = RowSelection & {
  searchValue: string;
  renderActionCell?: RenderActionCell;
};

export const NamedResourceTable = ({
  searchValue,
  onRowSelectionChange,
  rowSelectionState,
  renderActionCell
}: NamedResourceTableProps) => {
  const { data, isLoading } = useProfilesOptions({
    term: searchValue,
    profileVisibility: "active"
  });

  const columnsGenerator = useCallback(
    (columnHelper: ColumnHelper<BasicProfile>) => [
      createWorkforceMemberColumn(columnHelper),
      ...(renderActionCell
        ? [
            columnHelper.accessor((row) => row, {
              id: "action",
              header: () => null,
              cell: (info) =>
                renderActionCell({
                  data: info.getValue(),
                  option: ResourceTableOption.NamedResource
                }),
              enableSorting: false
            })
          ]
        : [])
    ],
    [renderActionCell]
  );

  if (isLoading) {
    return <LoadingDots circlesEnabled circleSize="sm" centered />;
  }

  const isSelectionEnabled = !!onRowSelectionChange;

  return (
    <Table<BasicProfile>
      tableData={data?.entries ?? []}
      generateColumns={columnsGenerator}
      enableRowSelection={isSelectionEnabled}
      onRowSelectionChange={onRowSelectionChange}
      rowSelection={rowSelectionState}
      disableHeader
      getRowId={(profile) => `${profile.id}`}
      disableAutoResizing
      onRowClick={
        onRowSelectionChange ? (rowData) => onRowSelectionChange({ [rowData.id]: true }) : undefined
      }
    />
  );
};
